import type IContactImage from '../../../models/press/contact-image.model';

export class ContactImageApiModel {
  public static mapToBusinessModel(apiModel: ContactImageApiModel): IContactImage | undefined {
    return {
      path: apiModel.path,
      focus: apiModel.focus,
    };
  }

  public path!: string;
  public focus!: string;
}
